module.exports = __webpack_public_path__ + "img/Primary-chevron.f44b01f4.svg";